import React from 'react';

const CHAT_DATE_FORMATTER = new Intl.DateTimeFormat('es-ES', {
  day: 'numeric', month: 'long', year: 'numeric'
});

const ChatDateSeparator: React.FC<{ timestamp: string; isFirst?: boolean }> = ({ timestamp, isFirst = false }) => {
  const date = new Date(timestamp);
  if (!Number.isFinite(date.getTime())) return null;
  const label = CHAT_DATE_FORMATTER.format(date);

  return (
    <div className={`${isFirst ? 'mb-6 mt-1 pl-12 pr-24 sm:px-0 md:pl-12 md:pr-[21rem] lg:px-0' : 'mb-4 mt-7'} flex w-full justify-center`} aria-label={`Fecha de la conversacion: ${label}`}>
      <div className="whitespace-nowrap rounded-full border border-line/40 bg-panel/65 px-2 py-1 text-[10px] font-medium leading-none text-muted shadow-sm shadow-black/5 sm:px-3 sm:text-[11px]">
        {label}
      </div>
    </div>
  );
};

export default ChatDateSeparator;
